/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'WRITTEN_POLICIES',
              'WRITTEN_PROCEDURES',
              'NO_WRITTEN_POLICIES_OR_PROCEDURES_IN_PLACE_BUT_INFORMAL_PROCEDU',
              'ARE_POLICIES_AND_OR_PROCEDURES_ENDORSED_BY_SENIOR_MANAGEMENT_',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_written_policies_andor_formal_procedures_for: valueSchema,
  },
}
